import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAxiosClient from "../../../hooks/useAxiosClient";
import { TRootState } from "../../../store";
import { TMarketDetailsById } from "../../../types/markets";
import {
  setMarketDetailsById,
  setMarketUpdated,
  setOpenMarketAddPanel,
  setOpenMarketDetailsPanel,
  setRefreshAllMarketsEntity,
  setRefreshMarketByIdEntity,
} from "../../../reducers/marketSlice";
import { TAllMarkets } from "../../../types/markets/market";
import { toast } from "react-toastify";
import { TLoanFiltersData } from "../../../types";

const useMarketDetailsById = () => {
  const { handleGetCall, handlePutCall } = useAxiosClient();
  const {
    adminId,
    role,
    openMarketDetailsPanel,
    selectedMarketId,
    marketDeatisById,
    allMarketsData,
    refreshMarketbyIdEntity,
    deletedMarketsList,
    activeMarketTab,
    apprRejectFields
  } = useSelector((state: TRootState) => ({
    adminId: state.auth.adminId,
    role: state.auth.userInfo?.roleType,
    openMarketDetailsPanel: state.marketDetails.openMarketDetailsPanel,
    selectedMarketId: state.marketDetails.selectedMarketId,
    marketDeatisById: state.marketDetails.marketDeatisById,
    allMarketsData: state.marketDetails.allMarketsData,
    refreshMarketbyIdEntity: state.marketDetails.refreshMarketbyIdEntity,
    deletedMarketsList: state.marketDetails.deletedMarketsList,
    activeMarketTab: state.marketDetails.activeMarketTab,
    apprRejectFields: state.marketDetails.apprRejectFields
  }));
  const [selectedMarket, setSelectedMarket] = useState<TAllMarkets | null>(
    null
  );
  const [deletMarketModalStatus, setDeletMarketModalStatus] = useState(false);
  const [selectDeleteMarkets, setSelectDelMarkets] =
    useState<TLoanFiltersData | null>(deletedMarketsList);
  const [rejectMarketModalStatus, setRejectMarketModalStatus] = useState(false);
  const [approveMarketModalStatus, setApproveMarketModalStatus] =
    useState(false);
  useEffect(() => {
    if (allMarketsData.length > 0) {
      const found =
        allMarketsData.find((m) => m.marketId === selectedMarketId) || null;
      setSelectedMarket(found);
    }
  }, [selectedMarketId]);

  const [showSeeAllCrops, setShowSeeAllCrops] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    marketDetailsById();
  }, [
    openMarketDetailsPanel,
    selectedMarket?.marketId,
    refreshMarketbyIdEntity,
  ]);

  const marketDetailsById = () => {
    setIsLoading(true);
    handleGetCall<TMarketDetailsById>(
      `admin/markets/mpower/adminId/${adminId}/marketId/${selectedMarketId}`
    )
      .then(({ data }) => {
        if (data) {
          dispatch(setMarketDetailsById(data));
        } else {
          dispatch(setMarketDetailsById(null));
        }
        setIsLoading(false);
      })
      .catch(() => {
        dispatch(setMarketDetailsById(null));
        setIsLoading(false);
      });
  };

  const onChangeMarketStatus = (status: string) => {
    handleMarketStatusChange(status);
  };

  const handleMarketStatusChange = (status: string) => {
    handlePutCall({
      URL: `admin/markets/mpower/status`,
      apiParams: {
        adminId: adminId,
        marketId: marketDeatisById?.marketId,
        status: status == "ACTIVE" ? 1 : 0,
      },
    }).then(async ({ data, status }) => {
      if (data) {
        toast.success(status.description);
        await dispatch(setRefreshMarketByIdEntity());
        await dispatch(setRefreshAllMarketsEntity());
        // await dispatch(setMarketUpdated(true));
      }
    });
  };

  const handleApproveMarket = () => {
    handlePutCall({
      URL: "admin/markets/mpower/status",
      apiParams: {
        marketId: marketDeatisById?.marketId,
        status: 1,
        adminId: adminId,
        remarks: apprRejectFields?.approveRemarks,
        marketOrs: apprRejectFields?.marketOrs,
        empOrs: apprRejectFields?.empOrs,
        onoId: marketDeatisById?.onoId
      }
    }).then(({ data, status }) => {
      if (data) {
        toast.success(status.description);
        dispatch(setRefreshMarketByIdEntity());
        dispatch(setRefreshAllMarketsEntity());
        setApproveMarketModalStatus(false);
        dispatch(setOpenMarketDetailsPanel(false));
      }
    });
  };

  const handleRejectMarket = () => {
    handlePutCall({
      URL: "admin/markets/mpower/status",
      apiParams: {
        marketId: marketDeatisById?.marketId,
        status: 3,
        adminId: adminId,
        remarks: apprRejectFields?.rejectRemarks,
      }
    }).then(({ data, status }) => {
      if (data) {
        toast.success(status.description);
        dispatch(setRefreshMarketByIdEntity());
        dispatch(setRefreshAllMarketsEntity());
        setRejectMarketModalStatus(false);
        dispatch(setOpenMarketDetailsPanel(false));
      }
    });
  };

  const onClickDeleteMarket = () => {
    if (!selectDeleteMarkets?.id) {
    }
    const obj = {
      adminId: adminId,
      destMarketId: selectDeleteMarkets?.id || "",
      srcMarketId: selectedMarketId,
    };
    handlePutCall({
      URL: "admin/markets/mpower/delete",
      apiParams: obj,
    })
      .then(async ({ data, status }) => {
        toast.success(status.description);

        await dispatch(setRefreshMarketByIdEntity());
        await dispatch(setRefreshAllMarketsEntity());
        setDeletMarketModalStatus(false);
        dispatch(setOpenMarketDetailsPanel(false));
      })
      .catch((err: any) => { });
  };
  const onCloseDeleteModal = () => {
    setDeletMarketModalStatus(false);
    setSelectDelMarkets(null);
  };

  return {
    marketDeatisById,
    showSeeAllCrops,
    setShowSeeAllCrops,
    onChangeMarketStatus,
    role,
    selectedMarketId,
    allMarketsData,
    selectedMarket,
    setSelectedMarket,
    isLoading,
    deletMarketModalStatus,
    setDeletMarketModalStatus,
    selectDeleteMarkets,
    setSelectDelMarkets,
    onClickDeleteMarket,
    onCloseDeleteModal,
    activeMarketTab,
    rejectMarketModalStatus,
    setRejectMarketModalStatus,
    approveMarketModalStatus,
    setApproveMarketModalStatus,
    handleApproveMarket,
    handleRejectMarket
  };
};
export default useMarketDetailsById;
